module.exports = __webpack_public_path__ + "img/hr-tree-07-f-leaves.36ebbd0b.png";